import _ from 'underscore'
import React from 'react'
import styled from 'styled-components'

import { useParams } from 'react-router-dom'

import TrendForm from 'pages/shared/TrendForm'

import useTrends from 'hooks/useTrends'
import { useStoreContext } from 'hooks/StoreContext'

import { PageHeader, PageTitle, LoadingSinglePanePage, SinglePanePage, screenSize } from 'styles/shared'

const EditTrend = () => {
  useTrends()

  const { trends, areTrendsLoaded } = useStoreContext()

  const { id } = useParams()
  if (!areTrendsLoaded) {
    return <LoadingSinglePanePage />
  }

  return (
    <>
      <PageHeader>
        <S.PageTitle>Edit Trend</S.PageTitle>
      </PageHeader>
      <S.SinglePanePage>
        <TrendForm
          saveMethod="update"
          trend={_.find(trends, trend => trend.id.toString() === id)}
        />
      </S.SinglePanePage>
    </>
  )
}

export default EditTrend

const S = {
  SinglePanePage: styled(SinglePanePage)`
    @media ${screenSize.small} {
      margin-top: 0;
    }
  `,
  PageTitle: styled(PageTitle)`
    @media ${screenSize.small} {
      display: block;
    }
  `
}
